<template>
  <div class="tarja-container" :style="containerPosition">
    <Wrapper class="tarja-svg" />
    <div class="header-text" :style="{ fontSize: headerFontSize }">{{ headerText }}</div>
    <div
      class="description-text"
      :style="{ fontSize: bodyTextSize, lineHeight: lineHeight }"
    >
      {{ text }}
    </div>
  </div>
</template>

<script>
import Wrapper from "@/assets/tarjas/tropa-ge/tarja-normal-v2.svg";

export default {
  props: {
    headerText: String,
    text: String,
    posicaoCard: String,
  },
  components: {
    Wrapper,
  },
  data() {
    return {};
  },
  computed: {
    containerPosition() {
      const positions = {
        esquerda: "left: 125px;",
        centro: "left: calc(50% - 350px);",
        direita: "right: 125px;",
      };
      return positions[this.posicaoCard] || positions.esquerda;
    },
    headerFontSize() {
      const numChars = this.headerText.trim().length;
      if (numChars > 18) {
        return "2.5rem";
      }
      return "3rem";
    },
    bodyTextSize() {
      const numChars = this.text.trim().length;
      const size =
        (numChars > 0) & (numChars <= 40)
          ? "3rem"
          : numChars > 40 && numChars <= 80
          ? "2.5rem"
          : numChars > 80 && numChars <= 120
          ? "2.3rem"
          : numChars > 120 && numChars <= 160
          ? "2.1rem"
          : numChars > 160 && numChars <= 200
          ? "2rem"
          : numChars > 200 && numChars <= 240
          ? "1.9rem"
          : numChars > 240 && numChars <= 280
          ? "1.8rem"
          : "1.5rem";
      return size;
    },
    lineHeight() {
      const numChars = this.text.trim().length;
      const lineHeight =
        (numChars > 0) & (numChars <= 40)
          ? "3rem"
          : numChars > 40 && numChars <= 80
          ? "3rem"
          : numChars > 80 && numChars <= 120
          ? "3rem"
          : numChars > 120 && numChars <= 160
          ? "2.5rem"
          : numChars > 160 && numChars <= 200
          ? "2.2rem"
          : numChars > 200 && numChars <= 240
          ? "2rem"
          : numChars > 240 && numChars <= 280
          ? "1.9rem"
          : "1.5rem";

      return lineHeight;
    },
  },
};
</script>

<style scoped lang="scss">
@font-face {
  font-family: "HeaderText";
  src: url("@/assets/fonts/GlobotipoPlacar-Black.otf") format("opentype");
}

@font-face {
  font-family: "BodyText";
  src: url("@/assets/fonts/Globotipo-Rounded-Bold.otf") format("opentype");
}

.tarja-container {
  // position: fixed;
  // bottom: -65px;
  // width: 700px;
  // height: 300px;
}

.tarja-svg {
  // width: 700px;
  // height: 300px;
}

.header-text {
  position: absolute;
  bottom: 186px;
  left: 180px;
  z-index: 100000;
  font-family: "HeaderText", sans-serif;
  color: #fe2045;
  width: 560px;
  text-transform: uppercase;
}

.description-text {
  position: absolute;
  bottom: 40px;
  left: 180px;
  z-index: 100000;
  font-family: "BodyText", sans-serif;
  color: rgb(255, 255, 255);
  width: 1140px;
  height: 140px;
  display: flex;
  align-items: center;
}
</style>
